var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"q",class:{ appeared: _vm.appeared },attrs:{"card":"","q-card":""}},[_c('div',{attrs:{"card-inner":""}},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }